import { defineStore } from 'pinia';

export type SidebarIcon = string | [string, string];

export type SidebarItemRouterType = {
	to: string;
	icon: SidebarIcon;
	label: string;
	badge_text?: string;
	badge_color?: string;
	disabled?: boolean;
	roles?: string[];
	values?: {
		[key: string]: string | number;
	};
};

export type SidebarItemLinkType = {
	href: string;
	icon?: SidebarIcon;
	label: string;
	disabled?: boolean;
	roles?: string[];
	values?: {
		[key: string]: string | number;
	};
};

export type SidebarItemDividerType = {
	divider: boolean;
};

export type SidebarItemHeaderType = {
	label: string;
	icon?: SidebarIcon;
	values?: {
		[key: string]: string | number;
	};
};

export type SidebarItemType =
	| SidebarItemRouterType
	| SidebarItemLinkType
	| SidebarItemDividerType
	| SidebarItemHeaderType;

export const useAppSidebarMenuStore = defineStore('appSidebarMenu', {
	state: () => ({
		items: [] as SidebarItemType[],
	}),
	actions: {
		set(items: Array<SidebarItemType>) {
			this.items = items;
		},
	},
});
